<template>
  <BlockEditoCreateSocialNetwork>
    <template #checkboxUseNetwork>
        <el-tooltip class="ml-1" placement="top-start" :content="$t('socialNetworkPosts.messageDisabledCheckbox')" :disabled="!(post.instagram.alreadyPublished || isDraftButtonDisabled)">
          <el-checkbox v-model="googleChecked" @change="checkPublishButtonState"
                       :disabled="post.instagram.alreadyPublished || isDraftButtonDisabled">
          </el-checkbox>
        </el-tooltip>
    </template>
    <template #iconAndTitleNetwork>
      <img
          alt=""
          :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)"
          width="20"
          style="padding-bottom: 8px;margin-right:15px;"
      />Google
    </template>

    <template #customize v-if="googleChecked && !post.google.alreadyPublished && user.haveGMBEdito">
      {{ $t('socialPosts.create.customizePost') }}
      <el-switch v-model="customGoogle" @change="confirmCustomOff" style="padding-left: 15px;"></el-switch>
    </template>
    <template #alreadyPublished v-if="post.google.alreadyPublished">
      <div v-html="$t('socialPosts.create.alreadyPublished')"></div>
    </template>
    <template #content>
      <div v-if="googleChecked && user.haveGMBEdito">
        <el-row style="margin-top: 20px">
          <el-col :lg="24">
            <el-form-item :label="$t('socialPosts.create.selectTypePost')" prop="typePostInputGoogle">
              <el-select v-model="post.google.typePost" :placeholder="$t('socialPosts.create.chooseTypeOfPost')"
                         :disabled="checkDisabled">
                <el-option value="STANDARD" :label="$t('socialPosts.create.typeNews')">
                  {{ $t('socialPosts.create.typeNews') }}
                </el-option>
                <el-option value="EVENT" label="Evénement">Evénement</el-option>
                <el-option value="OFFER" label="Offre">Offre</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div v-if="!post.initial.libelle">
              <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.IAButtonDisabled')"
                          placement="bottom">
                <el-button size="mini" type="success" @click="openModalIA()" :disabled="!post.initial.libelle"
                           v-if="customGoogle" style="margin-bottom: 15px;">{{ $t('socialPosts.create.redactWithAi') }}
                </el-button>
              </el-tooltip>
            </div>
            <div v-else>
              <el-button size="mini" type="success" @click="openModalIA()" :disabled="post.google.alreadyGeneratedAI"
                         style="margin-bottom: 15px;" v-if="customGoogle">{{ $t('socialPosts.create.redactWithAi') }}
              </el-button>
            </div>
            <el-form-item prop="texteInputGoogle">
              <div class="textarea-with-emojis">
                <el-input :rows="8"
                          type="textarea"
                          v-model="googleInputText"
                          :disabled="checkDisabled"
                          ref="textareaPostEditoGoogle">
                </el-input>
                <div>
                  <Emoji v-if="customGoogle" @addEmoji="addEmoji($event)" :disabled="checkDisabled" class="box-emojis"/>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24">
            <el-form-item label="Média" v-if="getStatusMediaPost.hasPhotos || getStatusMediaPost.hasVideoUrl || getStatusMediaPost.hasVideoUpload">
<!--              <el-checkbox :label="$t('socialPosts.create.dontuseAnotherPicture')" :disabled="checkDisabled" v-model="post.google.useAnotherPicture"></el-checkbox>-->
              <div v-if="post && post.photos.length > 0">
                <PostPhotosCustom network-name="google" :photos="post.photos.slice(0, 1)"/>
              </div>
              <div v-if="post && post.photos.length === 0 && getStatusMediaPost.hasPhotos">
                <!-- Miroir des photos uploadées depuis PostEditoCreatePublicationInitiale (limité à une photo pour Google) -->
                <el-row :gutter="50" v-if="post.initial.pictures && post.initial.pictures.length > 0">
                  <el-col :span="8" v-for="(photo, index) in post.initial.pictures.slice(0, 1)" :key="photo.url" style="padding-bottom: 20px" v-if="photo && photo.url">
                    <ubi-card :published="true" full-width class="uploaded-images-preview">
                      <img :key="photo.url" :src="photo.url" height="215" alt="" class="uploaded-image"/>
                    </ubi-card>
                  </el-col>
                </el-row>
              </div>
              <el-row v-if="getStatusMediaPost.hasVideoUrl && !getStatusMediaPost.hasVideoUpload">
                <el-col :span="24">
                  <el-form-item :label="$t('posts.networks.videoTitre')" :error="inputError">
                    <el-input v-model="linkToVideoInput" @change="updateLinkToVideo" type="url" :disabled="checkDisabled"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <upload-video
                v-if="getStatusMediaPost.hasVideoUpload"
                :post-id="post.id"
                network-name="initial"
                :none-display-button-remove="true"
              />

<!--              <post-edito-photos-upload-->
<!--                  v-if="post.google.useAnotherPicture"-->
<!--                  :post="post"-->
<!--                  network="google"-->
<!--                  :desactiver-champ="checkDisabled"-->
<!--                >-->
<!--                </post-edito-photos-upload>-->
            </el-form-item>
          </el-col>
        </el-row>
        <!--          <el-row v-if="post.google.typePost === 'OFFER'">-->
        <!--            <el-col :lg="24">-->
        <!--              <el-form-item :label="$t('socialPosts.create.promoCode')">-->
        <!--                <div style="margin-top: -38px; margin-left: 135px">-->
        <!--                  <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.promoCodeDetail')"-->
        <!--                              placement="bottom">-->
        <!--                    <em class="el-icon-question"></em>-->
        <!--                  </el-tooltip>-->
        <!--                </div>-->
        <!--                <el-input v-model="post.google.promoCode" :disabled="checkDisabled"></el-input>-->
        <!--              </el-form-item>-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <el-row v-if="post.google.typePost === 'OFFER'">
          <el-col :lg="24">
            <el-form-item :label="$t('socialPosts.create.offerLink')">
              <div style="margin-top: -38px; margin-left: 95px">
                <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.offerLinkDetail')"
                            placement="bottom">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </div>
              <el-input v-model="post.google.offerLink" :disabled="checkDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--          <el-row v-if="post.google.typePost === 'OFFER'">-->
        <!--            <el-col :lg="24">-->
        <!--              <el-form-item label="Conditions générales de l'offre">-->
        <!--                <div style="margin-top: -38px; margin-left: 204px">-->
        <!--                  <el-tooltip class="item" effect="dark" content="Détaillez les conditions générales permettant de profiter de l'offre."-->
        <!--                              placement="bottom">-->
        <!--                    <em class="el-icon-question"></em>-->
        <!--                  </el-tooltip>-->
        <!--                </div>-->
        <!--                <el-input v-model="post.google.offerConditions" :disabled="checkDisabled"></el-input>-->
        <!--              </el-form-item>-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <!--          <el-row  v-if="post.google.typePost && post.google.typePost !== 'OFFER'">-->
        <!--            <el-col :lg="24">-->
        <!--              <el-form-item :label="$t('socialPosts.create.actionButton')">-->
        <!--                <el-select v-model="post.google.actionButton" :placeholder="$t('socialPosts.create.typeOfActionButton')" :disabled="checkDisabled">-->
        <!--                  <el-option value="LEARN_MORE" :label="$t('socialPosts.create.learnMore')">{{ $t('socialPosts.create.learnMore') }}</el-option>-->
        <!--                </el-select>-->
        <!--              </el-form-item>-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <el-row v-if="post.google.typePost && post.google.typePost !== 'OFFER'">
          <el-col :lg="24">
            <el-form-item :label="$t('socialPosts.create.urlActionButton')" prop="eventLinkInput">
              <el-input v-model="post.google.offerLink" :disabled="checkDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="post.google.typePost && post.google.typePost !== 'OFFER'">
          <el-col :lg="24">
            <el-form-item label="UTM">
              <div style="margin-top: -38px; margin-left: 40px">
                <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.tooltipGoogleUTM')"
                            placement="bottom">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </div>
              <el-input v-model="post.google.UTM" :disabled="checkDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="post.google.typePost && post.google.typePost !== 'STANDARD'">
          <el-col :lg="22">
            <el-form-item label="Dates" prop="eventDatesGoogle">
              <el-date-picker
                  type="daterange"
                  :value="[
                    post.google.offerDateBefore,
                    post.google.offerDateAfter
                  ]"
                  v-model="dates"
                  :start-placeholder="$t('general.filters.dateCreationStart')"
                  :end-placeholder="$t('general.filters.dateCreationEnd')"
                  @input="dates => changeDate({ before: dates[0], after: dates[1] })"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  :disabled="checkDisabled"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="googleChecked && !user.haveGMBEdito">
        <div style="margin-top: 8px;"
             v-html="$t('socialPosts.diffusionDisabled', { networkName: 'Google My Business'})"></div>
        <hr/>
        <div class="text-right">
          <el-row>
            <el-button type="primary" @click="sendMail('Google My Business')">
              {{ $t('socialPosts.iWantToEnableThisNetwork') }}
            </el-button>
          </el-row>
        </div>
      </div>
    </template>
  </BlockEditoCreateSocialNetwork>
</template>

<script>
import Emoji from '@/components/emojis/Emoji'
import PostEditoPhotosUpload from '@/pages/socialNetworks/components/PostEditoPhotosUpload'
import { mapGetters, mapMutations, mapState } from 'vuex'
import BlockEditoCreateSocialNetwork from '@/pages/socialNetworks/components/BlockEditoCreateSocialNetwork'
import { $t } from '@/i18n'
import UploadVideo from '@/components/Upload/UploadVideo.vue'
import PostPhotosCustom from '@/pages/posts/SocialMedia/components/PostPhotosCustom.vue'
import UbiCard from '@/components/Card'
import PostEditoValidationMixin from "@/mixins/PostEditoValidationMixin";

export default {
  name: 'PostEditoCreateGoogle',
  components: {
    PostPhotosCustom,
    UploadVideo,
    Emoji,
    PostEditoPhotosUpload,
    BlockEditoCreateSocialNetwork,
    UbiCard
  },
  props: ['post'],
  mixins: [PostEditoValidationMixin],
  data () {
    return {
      checkDisabled: true,
      pickerOptions: {},
      toto: false,
      dates: [],
      inputError: ''
    }
  },
  watch: {
    customGoogle: function (custom) {
      if (custom) {
        if (this.post.google.offerDateBefore && this.post.google.offerDateAfter) {
          this.dates = [this.post.google.offerDateBefore, this.post.google.offerDateAfter]
        }
        this.checkDisabled = false
      } else {
        this.checkDisabled = true
      }
      return this.checkDisabled
    }
  },
  computed: {
    ...mapGetters('socialPostsCreationPostEditorial', ['getStatusMediaPost']),
    ...mapGetters('postManager', ['getCurrentPost']),
    ...mapState('socialPostsCreationPostEditorial', ['customGoogle', 'googleChecked']),
    googleChecked: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/getGoogleChecked']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setGoogleChecked', value)
      }
    },
    customGoogle: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/getCustomGoogle']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setCustomGoogle', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    linkToVideoInput: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.google.linkToVideo
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/updateInputVideoGoogle', value)
      }
    },
    googleInputText: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.google.inputText
      },
      set (value) {
        if (this.customGoogle) {
          this.$store.commit('socialPostsCreationPostEditorial/updateInputTextGoogle', value)
        } else {
          this.$store.commit('socialPostsCreationPostEditorial/updateInputTextInitial', value)
        }
      }
    }
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setCustomGoogle',
        'setGoogleChecked',
        'setModalIA',
        'checkPublishButtonState',
        'setOfferDateGoogle',
        'setNetworkClicked']),
    openModalIA () {
      this.setNetworkClicked('google')
      this.setModalIA(true)
    },
    updateLinkToVideo (value) {
      this.inputError = ''
      if (!value || this.urlIsValid(value)) {
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      } else {
        this.inputError = $t('posts.networks.videoUrlError')
        this.$emit('updateValue', 'setError', this.inputError)
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', true)
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', true)
        this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 4000 })
        return false
      }
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
          (urlVideo.hostname.indexOf('youtube') === -1) &&
          (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    changeDate (event) {
      console.log(event)
      this.post.google.offerDateBefore = event.before
      this.post.google.offerDateAfter = event.after
      // this.setOfferDateGoogle(this.dates)
    },
    addEmoji (emoji) {
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEditoGoogle.$el.querySelector('.el-textarea__inner')

      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.googleInputText) {
        textarea.innerHTML += insertText
      }
      if (this.googleInputText) {
        this.googleInputText = this.googleInputText.substring(0, cursorIndex) + insertText + this.googleInputText.substring(cursorIndex)
      } else {
        this.googleInputText = insertText
      }

      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    confirmCustomOff (value) {
      if (this.customGoogle === false) {
        this.$store.commit('socialPostsCreationPostEditorial/setModalStopCustom', true)
        this.$store.commit('socialPostsCreationPostEditorial/setStopCustomNetwork', 'google')
        this.inputError = ''
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      }
    },
    sendMail (network) {
      this.$store.dispatch('socialPostsCreationPostEditorial/sendEmailEnableNetwork', network)
    }
  },
  beforeMount () {
    if (this.customGoogle) {
      this.checkDisabled = false
    } else {
      this.checkDisabled = true
    }
    if (this.post.google.alreadyPublished) {
      this.checkDisabled = false
    } else {
      this.checkDisabled = true
    }
  }
}
</script>

<style scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: -5px;
  z-index: 3;
}

.el-form--label-top .el-form-item .el-form-item__label {
  color: #184a56;
  line-height: 1.5;
  font-weight: bold;
}

.uploaded-images-preview {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin-left: 0;
}

.uploaded-image {
  margin: 0;
  padding: 0;
  max-width: 180px;
  object-fit: cover;
}
</style>
